import React from 'react';
import {
  FiClock, FiBriefcase, FiEdit2, FiFlag, FiImage, FiEye, FiLink, FiX,
  FiSend, FiCheckCircle, FiLock, FiHeart, FiDownload, FiMessageSquare,
  FiUploadCloud, FiTrash2, FiClipboard
} from 'react-icons/fi';

const ACTIVITY_ICONS = {
  job_created: { icon: FiBriefcase, color: '#304849' },
  job_updated: { icon: FiEdit2, color: '#435654' },
  job_stage_changed: { icon: FiFlag, color: '#3e5c58' },
  gallery_created: { icon: FiImage, color: '#304849' },
  gallery_published: { icon: FiEye, color: '#10b981' },
  gallery_unpublished: { icon: FiEye, color: '#3e5c58' },
  token_created: { icon: FiLink, color: '#304849' },
  token_opened: { icon: FiEye, color: '#3e5c58' },
  token_revoked: { icon: FiX, color: '#ef4444' },
  selection_request_sent: { icon: FiSend, color: '#3e5c58' },
  selection_request_opened: { icon: FiEye, color: '#3e5c58' },
  selection_submitted: { icon: FiCheckCircle, color: '#10b981' },
  selection_locked: { icon: FiLock, color: '#435654' },
  asset_favorited: { icon: FiHeart, color: '#ef4444' },
  asset_unfavorited: { icon: FiHeart, color: '#435654' },
  asset_downloaded: { icon: FiDownload, color: '#304849' },
  comment_added: { icon: FiMessageSquare, color: '#3e5c58' },
  document_uploaded: { icon: FiUploadCloud, color: '#304849' },
  document_deleted: { icon: FiTrash2, color: '#ef4444' },
  note_added: { icon: FiClipboard, color: '#3e5c58' }
};

function formatRelativeTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export default function ActivityCard({ activity, onViewAllClick }) {
  const isEmpty = !activity || activity.length === 0;

  return (
    <div className="ws-card full-width">
      <div className="ws-card-header">
        <h4><FiClock size={15} /> Recent Activity</h4>
        {!isEmpty && (
          <button className="ws-card-action" onClick={onViewAllClick}>View All</button>
        )}
      </div>

      {isEmpty ? (
        <div className="ws-card-empty">
          <FiClock size={32} />
          <p>No activity recorded yet</p>
        </div>
      ) : (
        <div className="ws-card-body">
          <div className="activity-list-compact">
            {activity.slice(0, 5).map(item => {
              const config = ACTIVITY_ICONS[item.event_type] || { icon: FiClock, color: '#435654' };
              const Icon = config.icon;
              return (
                <div key={item.id} className="activity-row-compact">
                  <div className="activity-icon-sm" style={{ background: `${config.color}15`, color: config.color }}>
                    <Icon size={13} />
                  </div>
                  <div className="activity-row-content">
                    <span className="activity-text">
                      {item.event_summary || item.event_type.replace(/_/g, ' ')}
                    </span>
                    <span className="activity-time">{formatRelativeTime(item.created_at)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
